import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import {
  parsePoliciesThroughputIgnoringSpeeds,
  policiesThroughputRetrieval,
} from "./api";
import View from "common/View";
import help from "help/viewSubscribersPerPolicy.md";

const retrieval = ({ hours, policyType, mode, bqnId }) =>
  policiesThroughputRetrieval({ hours, type: policyType, mode, bqnId })
    .then(parsePoliciesThroughputIgnoringSpeeds)
    .catch((error) => console.error(error) || error)

const enabled = {
  policyType: true,
  hours: true,
  directions: false,
  categories: false,
  target: false,
  output: false,
  filter: false,
};

const PerPolicySubscribersView = ({ returnView = null }) => {
  const actions = useContext(ActionsContext);
  return (
    <View title="Subscribers per policy by time" mdHelp={help} returnView={returnView}>
      <Report
        returnView={returnView}
        from="timeline"
        itemsFrom="policies"
        itemsValueFrom="subscribers"
        yAxisUnits="Subscribers"
        yAxisPrecision={0}
        provider={retrieval}
        actions={actions}
        enabled={enabled}
      />
    </View>
  );
};

export default PerPolicySubscribersView;
